import { render, staticRenderFns } from "./material-desc.vue?vue&type=template&id=6074df2b&scoped=true"
import script from "./material-desc.vue?vue&type=script&lang=js"
export * from "./material-desc.vue?vue&type=script&lang=js"
import style0 from "./material-desc.vue?vue&type=style&index=0&id=6074df2b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6074df2b",
  null
  
)

export default component.exports